var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingleUserSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SingleUserSearch_svg__a,.SingleUserSearch_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:1.5px}.SingleUserSearch_svg__a{stroke-linejoin:round}.SingleUserSearch_svg__b{stroke-linejoin:bevel}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SingleUserSearch_svg__a",
    d: "M12.469 3.023a3.492 3.492 0 11-4.938 0 3.492 3.492 0 014.938 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SingleUserSearch_svg__b",
    d: "M14.363 12.8A11.938 11.938 0 0010 11.991c-4.048 0-8 1.967-8 4.992v1a1 1 0 001 1h9.413"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SingleUserSearch_svg__b",
    d: "M17 22a5 5 0 01-5-5 5.077 5.077 0 015-5 5 5 0 010 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SingleUserSearch_svg__a",
    d: "M18.125 15.3a2 2 0 11-2.827 0 2 2 0 012.827 0M19 19l-.88-.88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgSingleUserSearch;


//////////////////
// WEBPACK FOOTER
// ./src/icons/SingleUserSearch.svg
// module id = 832
// module chunks = 101